export const smartHomeSubmenus = [
  {
    id: 1,
    link: "#smart-home-solution",
    label: "Smart Home Solution",
  },
  {
    id: 2,
    link: "#smart-home-eco-system",
    label: "Smart Home Eco System",
  },
  {
    id: 3,
    link: "#smart-home-system",
    label: "Smart Home System",
  },
  {
    id: 4,
    link: "#mechanical-&-electrical",
    label: "Mechanical & Electrical",
  },
];
